/**
 * Singleton formatters for consistent and performant formatting across the app.
 * Creating Intl.NumberFormat instances is expensive - these should be reused.
 */

// Currency formatter for Brazilian Real
export const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

// Currency formatter without decimals (for charts)
export const currencyFormatterCompact = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

// Currency formatter with 2 decimal places (explicit)
export const currencyFormatterFull = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Number formatter for percentages
export const percentFormatter = new Intl.NumberFormat("pt-BR", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

// Number formatter for decimals
export const decimalFormatter = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// Helper function to format currency (convenience wrapper)
export const formatCurrency = (value: number): string => {
  return currencyFormatter.format(value);
};

// Helper function to format currency compact (convenience wrapper)
export const formatCurrencyCompact = (value: number): string => {
  return currencyFormatterCompact.format(value);
};

// Transaction amounts are stored as magnitudes; expenses are represented as
// negative values only when displayed, filtered, sorted, or exported.
export const getSignedTransactionValue = (
  value: number,
  type: "receita" | "despesa"
): number => {
  const magnitude = Math.abs(Number.isFinite(value) ? value : 0);
  return type === "despesa" ? -magnitude : magnitude;
};

export const formatTransactionCurrency = (
  value: number,
  type: "receita" | "despesa"
): string => {
  const signedValue = getSignedTransactionValue(value, type);
  const sign = signedValue < 0 ? "-" : "";
  return `R$ ${sign}${decimalFormatter.format(Math.abs(signedValue))}`;
};
